import { NavLink } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Slider from "react-slick";



const homeUrl = process.env.REACT_APP_HOME_URL;


const News = () => {
	const [loading, setLoading] = useState(false);
	const [skeletoncard, setSkeletonCard] = useState(true);
	const [articles, setArticles] = useState([]);
	const [banners, setBanners] = useState([]);
	const [viewType, setViewType] = useState('grid_main_sec'); 

	const toprecent_slider = {
	    dots: true,
	    arrows: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    autoplay: true,
	    autoplaySpeed: 2000,
	};

	useEffect(() => {
		const fetchRSS = async () => {
			setLoading(true)
			try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/get-news`);
				const data = await response.json();    
				console.log(data);
				setArticles(data.items);
				setBanners(data.banner);
				setLoading(false);
				setSkeletonCard(false);
			} catch (err) {
				console.error('Error fetching RSS feed:', err);
				setLoading(false);
			}
		};

		fetchRSS();
	}, []);

	const formatDate = (dateString) => {
	  const date = new Date(dateString);
	  return date.toLocaleString('en-US', {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: '2-digit',
	    hour12: true
	  });
	};

	const handleChange = (e) => {
	    setViewType(e.target.value);
	    console.log('Selected view:', e.target.value); // optional
	};

return (

<div className="news_wrapper">
	<div className="toprecent_newsbox">
        <div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="toprecent_slider">
						{skeletoncard && (
							<div className="skeleton-card">
								<div className="newsbox">
									<div className="imgbox">
										<div className="skeleton skeleton-thumbnail"></div>
									</div>
									
									<div className="contntbox">
										<div className="contnt_secbox">
											<div className="categorybox">
												<div className="categorytxt">
													<div className="skeleton skeleton-small-text"></div>
												</div>
											</div>

											<div className="author_info">
												<div className="skeleton skeleton-text"></div>
											</div>

											<div className="titlebox">
												<div className="skeleton skeleton-title"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					
						<Slider {...toprecent_slider}>
							{banners.map((item, index) => (
							<div className="newsbox">
								<div className="contntbox" style={{ backgroundImage: `url(${item.image})` }}>
									<div className="contnt_secbox">
										<div className="categorybox">
											<div className="categorytxt">
												<span>{item.Source}</span>
											</div>
										</div>

										<div className="author_info">

											<div className="iconbox">
												<i className="far fa-calendar"></i>
												<span>{formatDate(item.pubDate)}</span>
											</div>
											{/*
											<div className="iconbox">
												<i className="fas fa-th-large"></i>
												<span>{item.categories && item.categories.join(', ')}</span>
											</div>
											*/}
										</div>

										<div className="titlebox">
											<h2><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${item.Source}`}>{item.title}</a></h2>
										</div>
									</div>
								</div>
							</div>
							))}
						</Slider>
					</div>
				</div>
			</div>
        </div>
	</div>
	
	
	<div className={`articals_mainsec news_mainsec ${viewType}`}>
		<div className="container">
			<div className="row">
				{!skeletoncard && (
				<>
				<div className="col-sm-8 col-md-8 col-lg-8 col-xl-8">
					<div className="title_mainsec">
						<h2>Latest News</h2>
					</div>
				</div>
				
				<div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
					<div className="optionbox">
						<div className="listgrid_box">
							<select onChange={handleChange}>
								<option value="grid_main_sec">Grid</option>
								<option value="list_main_sec">List</option>
							</select>
						</div>
					</div>
				</div>
				</>
				)}
				{skeletoncard && (
					<div className="skeleton-card">
						<div className="row">
							<div className="col-sm-12 col-md-8 col-lg-8 col-xl-8">
								<div className="title_mainsec">
								<div className="skeleton skeleton-title"></div>
								</div>
							</div>
							
							<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<div className="optionbox">
									<div className="skeleton skeleton-text"></div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			
			<div className="row">

				{skeletoncard && (
					<>
					{[...Array(4)].map((_, i) => (
						<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<div className="skeleton-card">
								<div className="articals_mainbox">
									<div className="articals_imgbox">
										<div className="skeleton skeleton-thumbnail"></div>
									</div>
									
									<div className="articals_contntbox">
										<div className="artical_contnt">
											<div className="skeleton skeleton-title"></div>
										</div>
										
										<div className="artical_info">
											<div className="skeleton skeleton-small-text"></div>
											<div className="skeleton skeleton-small-text"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
					</>
				)}
				{articles.map((item, index) => (
					<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
						<div className="articals_mainbox">
							<div className="articals_imgbox">
								<img alt="Crypto News Image" src={item.image} />
							</div>
							
							<div className="articals_contntbox">
								<div className="artical_contnt">
									<h3><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${item.Source}`}>{item.title}</a></h3>
								</div>
								
								<div className="artical_info">
									<span className="categorytxt">
										<span>{item.Source}</span>
									</span>
									<span className="time_txt">{formatDate(item.pubDate)}</span>
								</div>
							</div>
						</div>
						
						
					</div>
				))}
			</div>
		</div>
	</div>
</div>

);
};

export default News;